module.exports = {
  MinecraftNintendoSwitch: '00000000441cc96b',
  MinecraftJava: '00000000402b5328',
  XboxAppIOS: '000000004c12ae6f',
  XboxGamepassIOS: '000000004c20a908'
}
